class Session {
    ROLE = Object.freeze({
      customer: 'WEB_USER',
      admin: 'WEB_ADMIN',
    });

    constructor(json) {
      const { role, firstName, lastName } = json || {};

      this.role = Object.values(this.ROLE).find((r) => (r === role));
      // for dev: this.role = 'WEB_ADMIN';
      if (!this.isAuthenticated) {
        return;
      }

      this.firstName = firstName;
      this.lastName = lastName;
    }

    get isAuthenticated() {
      return !!this.role;
    }

    get isAdmin() {
      return this.role === this.ROLE.admin;
    }

    get isNormalUser() {
      return this.role === this.ROLE.customer;
    }
}

export default Session;
